import { UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '../../contentful/Client';

import {
  GetRadarQuery,
  useGetRadarQuery,
} from '../../generated/graphql';


export const useRadarConfiguration = (
  radarName: string | undefined,
  options?: UseQueryOptions<GetRadarQuery>,
) => {
  return useGetRadarQuery(
    gqlClient(false),
    {
      preview: false,
      slug: radarName || "engineering",
    },
    options,
  );
};
